import angular from 'angular';
import RoutingConfig from './offerings.config';
import OfferingsComponent from './offerings.component';
export default angular.module('invision.customercare.customer.offerings', []).config(RoutingConfig).component('offerings', OfferingsComponent).name;